export function borgerDk() {
  if(jQuery(".borgerdk--accordion").length > 0){
    updateLinks();
  }
}

// NOTE (U17): den tidligere CheckArticle()-freshness-check er fjernet. Den ramte U13-ruten
// /umbraco/api/BorgerDkArticle/CheckForUpdates, som ikke længere findes (porteret til den
// backoffice-auth'ede /umbraco/management/api/v1/borgerdk/...), dens trigger-markup
// (.js-borgerdk-accordion + data-articleid/-lastupdated) blev aldrig renderet, og success-handleren
// var tom. Freshness håndteres nu server-side af Hangfire auto-update + management check-for-updates.

function updateLinks() {
  jQuery(".borgerdk--accordion").find("a[href]").each(function () {
    var href = jQuery(this).attr("href");
    if (href.indexOf("borger.dk") > -1) {
      jQuery(this).attr("target", "_blank");
    }
  });
}
export default borgerDk;
